import React, { useState } from 'react';
import './banner-styles.less';
import { AssementFooter } from '../AssessmentFooter';
import { Radio } from 'components';

function ConsentButton({ checked, onChange }) {
  return (
    <Radio
      checked={checked}
      name="consent"
      onChange={onChange}
      label={<>I understand</>}
      type="checkbox"
    />
  );
}

export function StatementBanner({
  onBack = () => { },
  onNext = () => { },
  hideNext = false,
  hideBack = false,
  title,
  subtitle,
  subsubtitle,
  footer,
  needsConsent,
  children,
}) {
  const [consented, setConsented] = useState(false);

  return (
    <div
      className="yellow_background"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'flex-start',
      }}>
      <div>
        <AssementFooter
          onBack={onBack}
          onNext={onNext}
          primary
          hideNext={hideNext}
          hideBack={hideBack}
          disableNext={needsConsent && !consented}
        />
      </div>
      <div className="title_banner_container">
        <div className="title_container banner_container">
          <h1
            className="label statement_title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <h2
            className="label statement_subtitle"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
          <h3
            className="label statement_subsubtitle"
            dangerouslySetInnerHTML={{ __html: subsubtitle }}
          />
          {children}
          {needsConsent && (
            <ConsentButton
              checked={!needsConsent || consented}
              onChange={() => setConsented((v) => !v)}
            />
          )}
          <h2
            className="label statement_subtitle"
            dangerouslySetInnerHTML={{ __html: footer }}
          />
        </div>
      </div>
    </div>
  );
}